// extracted by mini-css-extract-plugin
module.exports = {"container":"dash-header_container__j-Mz4","logo":"dash-header_logo__2eps7"};